var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTractorimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "blue",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-tractor-icon lucide-tractor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18h-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5a1 1 0 0 0-1 1v5.573"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11V4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1V4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorimg);
export default __webpack_public_path__ + "static/media/tractorimg.bba27b266835ed97864f379e2bead232.svg";
export { ForwardRef as ReactComponent };